export const Arrow = () => (
    <svg
        width="45"
        height="46"
        viewBox="0 0 45 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`
          scale-75

          sm:scale-100
        `}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.08839 24.7416L24.2971 42.9503L21.8727 45.3747L0.735984 24.2379L0.735983 21.8136L21.8727 0.676827L24.2971 3.10119L6.08524 21.3131H44.9967V24.7416H6.08839Z"
            fill="#313131"
        />
    </svg>
);
